import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const updateDiplomeApi = createAsyncThunk(
  "diplome/update",
  async (diplomeData) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/diplome/update/${diplomeData.diplomeId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
        body: JSON.stringify(diplomeData.data),
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("response", result);
        return result;
      })
      .catch((error) => {
        console.log("error", error);
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const updateDiplomeSlicer = createSlice({
  name: "update diplome",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateDiplomeApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateDiplomeApi.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(updateDiplomeApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      formatError(state.error);
    });
  },
});

export default updateDiplomeSlicer.reducer;
